import { render, staticRenderFns } from "./LastSearches.vue?vue&type=template&id=a92aa7ec&scoped=true&"
import script from "./LastSearches.vue?vue&type=script&lang=js&"
export * from "./LastSearches.vue?vue&type=script&lang=js&"
import style0 from "./LastSearches.vue?vue&type=style&index=0&id=a92aa7ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92aa7ec",
  null
  
)

export default component.exports